module.exports = __webpack_public_path__ + "img/2.e112beb6.jpeg";